export const buildProductionApiUrl = (basePath: string, websocketProtocol: boolean = false) => {
  const currentLocation = window.location;
  const hostname = currentLocation.hostname;
  const labels = hostname.split(".");

  // Ensure we only run against the expected voyc.ai domains.
  if (labels.length < 2 || labels.slice(-2).join(".") !== "voyc.ai") {
    throw new Error(`Unsupported hostname "${hostname}". Expected *.voyc.ai`);
  }

  const protocol = websocketProtocol ? "wss:" : "https:";
  const [, ...domainParts] = labels;
  const apiHost = ["api", ...domainParts].join("."); // alex.develop.voyc.ai -> api.develop.voyc.ai
  return `${protocol}//${apiHost}${basePath ? basePath : ""}`;
};
